import { render, staticRenderFns } from "./AlertDialogFrame.vue?vue&type=template&id=4c6c6571&scoped=true&"
import script from "./AlertDialogFrame.vue?vue&type=script&lang=ts&"
export * from "./AlertDialogFrame.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDialogFrame.vue?vue&type=style&index=0&id=4c6c6571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c6571",
  null
  
)

export default component.exports